import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clubFee'
})
export class ClubFeePipe implements PipeTransform {

  transform(value: string): string {
    let feeCharges = Number(value);
    let creditCardFee = (0.04 * feeCharges) > 1 ? (0.04 * feeCharges) : 1; // 4%, min $1
    let managementFee = this.managementFeeCalculation(feeCharges);
    let total = feeCharges + managementFee + creditCardFee;
    return Number(total).toFixed(2);
  }

  // Flat $10 Panda fee (was 5% of the club fee, clamped to $5-$10).
  // Keep in sync with PANDA_FEE in add-finance-form.component.ts.
  managementFeeCalculation(feeCharges) {
    return 10;
  }

}



